/**
 * Shared admin utilities
 *
 * Common types and helpers used across admin pages and components.
 */

/**
 * Pagination state returned by admin API endpoints.
 */
export interface PaginationInfo {
  page: number;
  limit: number;
  total: number;
  totalPages: number;
}

/**
 * Default pagination state for admin list pages.
 */
export const DEFAULT_PAGINATION: PaginationInfo = {
  page: 1,
  limit: 20,
  total: 0,
  totalPages: 0,
};

/**
 * Format a date string for display in admin tables.
 *
 * @param dateString - ISO date string, or null/undefined
 * @returns Formatted date like "Jan 1, 2025", or "Never" for null values
 */
export function formatDate(dateString: string | null | undefined): string {
  if (!dateString) return 'Never';
  return new Date(dateString).toLocaleDateString('en-US', {
    year: 'numeric',
    month: 'short',
    day: 'numeric',
  });
}
